"use client"
import React, { useState } from "react";

export default function GoToLink(props) {
  const [data, setData] = useState({
    ownerId: props.ownerId,
    contentId: props.contentId,
    type: props.type,
    url: props.url
  });

  const getBase64 = data => {
    if (data.typeOf !== "string") {
      data = JSON.stringify(data);
    }
    var base64 = Buffer.from(data).toString("base64");
    return encodeURIComponent(base64);
  };

  return (
    <a
      className={props.classProps}
      href={"/goto/" + getBase64(data)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={evt => evt.stopPropagation()}
    >
      {props.toRender}
    </a>
  );
}
